import type { RootState } from '@/store/store';
import type { CONFIG_SCHEMA } from './screenConfigSlice';
import type { StatTestingOptionEntry } from './moduleConfig.types';

/**
 * Whether the active screen config wants demographic/behavioral filters
 * included in outbound V2 analytics payloads. Defaults to `true` when the
 * config hasn't resolved yet (registry starts as `{}` before a route
 * registers its config) — every real `CONFIG_SCHEMA` entry sets this field
 * explicitly, so the fallback only matters in the brief pre-registration
 * window, which payload hooks already gate on separately.
 */
export const selectApiSendFilters = (s: RootState): boolean =>
  (s.screenConfig as CONFIG_SCHEMA)?.apiSendFilters ?? true;

/**
 * Returns the ordered stat-testing option config array for the active screen.
 *
 * - Returns `undefined` when the screen has no `statTestingConfig` (stat testing
 *   not supported on this screen).
 * - Returns an empty array when the config is explicitly set to `[]` (stat testing
 *   is hidden entirely).
 * - Otherwise returns the array as-is; the `StatTesting` component uses the
 *   array order for rendering and evaluates each entry's rules at runtime.
 */
export const selectStatTestingConfig = (s: RootState): StatTestingOptionEntry[] | undefined =>
  (s.screenConfig as CONFIG_SCHEMA)?.statTestingConfig;
